import React from 'react';
import { Link } from 'react-router-dom';
import { LiveClassCard } from '../PlayfulShared/LiveClassCard';

export function LiveClassCardStudent({ liveClass, status }) {
  return (
    <LiveClassCard
      liveClass={liveClass}
      status={status}
      testId="live-class-card-student"
    >
      {status === 'ao-vivo' ? (
        <Link
          to={String(liveClass.id)}
          className="mt-1 block w-full rounded-full py-2 text-center text-xs font-extrabold text-white transition-transform duration-100 active:translate-y-px"
          style={{ background: 'var(--gradient-btn-continue)', boxShadow: '0 3px 0 var(--color-mission-dark)' }}
        >
          Acessar
        </Link>
      ) : (
        <span className="mt-1 block w-full rounded-full bg-[#ECE9F8] py-2 text-center text-xs font-extrabold text-gray-400">Acessar</span>
      )}
    </LiveClassCard>
  );
}
